module.exports = __webpack_public_path__ + "img/Z61Q_12.33b8036f.jpg";